import { Box, ButtonBase } from "@mui/material";
import { Moped, Store } from "@mui/icons-material";
import { TipoPedido, TipoPedidoTitulo } from "../../../../enum/TipoPedido";
import { useChatPdVContext } from "../../../../contexts/atendimento/ChatPdVContext";
import { alpha } from "@mui/material/styles";
import { contorno, cores, raio, superficie } from "../../identidade";

export const ChatPdVTipoPedidoRadio = () => {
    const { tipo, alterarTipo } = useChatPdVContext();

    const opcoes = [
        { value: TipoPedido.delivery, label: TipoPedidoTitulo.delivery, icon: Moped },
        { value: TipoPedido.retirada, label: TipoPedidoTitulo.retirada, icon: Store },
    ];

    return (
        <Box
            sx={{
                p: 0.4,
                borderRadius: raio.sm,
                display: 'flex',
                gap: 0.4,
                backgroundColor: theme => superficie(theme, 0.05),
                border: theme => contorno(theme, 0.08),
            }}
        >
            {opcoes.map((opcao) => {
                const isSelected = tipo === opcao.value;
                const Icon = opcao.icon;

                return (
                    <ButtonBase
                        key={opcao.value}
                        onClick={() => alterarTipo(opcao.value)}
                        sx={{
                            flex: 1,
                            py: 1,
                            px: 1.25,
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            fontSize: '12px',
                            fontWeight: 700,
                            transition: 'background-color .16s, color .16s',
                            ...(isSelected
                                ? {
                                    backgroundColor: alpha(cores.marca[500], 0.14),
                                    color: cores.marca[500],
                                }
                                : {
                                    backgroundColor: 'transparent',
                                    color: 'text.secondary',
                                    '&:hover': { backgroundColor: theme => superficie(theme, 0.05) },
                                }),
                        }}
                    >
                        <Icon sx={{ fontSize: 16 }} />
                        {opcao.label}
                    </ButtonBase>
                );
            })}
        </Box>
    );
};

